import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RowStyle } from 'apps/repository/styles';
import { FileIcon } from 'apps/repository/views/columns/icon';
import { Name } from 'apps/repository/views/columns/name';
import { Message } from 'apps/repository/views/columns/message';
import { LastModified } from 'apps/repository/views/columns/lastModified';
import { Actions } from 'apps/repository/views/columns/actions';

@observer
export class Row extends React.Component {
  dragOver = () => {
    const { dragState, fileInfo, canContribute } = this.props;
    if (!canContribute) return;
    dragState.DragOver(fileInfo);
  };

  dragStart = () => {
    const { dragState, fileInfo, canContribute } = this.props;
    if (!canContribute) return;
    dragState.DragStart(fileInfo);
  };

  render() {
    const { fileInfo, last, canContribute, project } = this.props;
    const file = fileInfo.reference;
    // const draggedOverFile =
    //   dragState.dragOverItem && dragState.dragOverItem.reference;
    // const highlighted =
    //   draggedOverFile && draggedOverFile.id === file.id && file.isFolder;

    // FIXME: Disable draggabe for now!!!!
    // draggable={false}
    // highlighted={highlighted}
    // faded={dragState.dragging && !file.isFolder}
    // onDragOver={this.dragOver}
    // onDragStart={this.dragStart}
    // onDragEnd={dragState.DragEnd}
    return (
      <RowStyle
        noColorChange={!!file && file.renaming}
        last={last}
        data-intercom-target={this.props.index === 0 ? 'project-drive' : ''}
      >
        <FileIcon fileInfo={fileInfo} />
        <Name fileInfo={fileInfo} fieldName='newFilename' project={project} />
        <Message fileInfo={fileInfo} project={project} />
        <LastModified fileInfo={fileInfo} />
        <Actions
          fileInfo={fileInfo}
          canContribute={canContribute}
          project={project}
        />
      </RowStyle>
    );
  }
}

Row.propTypes = {
  app: PropTypes.object,
  contribFile: PropTypes.object,
  operations: PropTypes.object,
  canContribute: PropTypes.bool,
  last: PropTypes.bool,
  fileInfo: PropTypes.object,
  project: PropTypes.object,
  dragState: PropTypes.object,
  index: PropTypes.number,
};
